import {useCallback} from "react";
import {postUpdateUser} from "../api";
import {useToast} from "use-toast-mui";

export const useUpdateUserEmail = () => {
    const toast = useToast();

    const updateUserEmail = useCallback(async (activationKey: string, email: string, billingEmail?: string): Promise<void> => {
        try {
            await postUpdateUser(activationKey, email, billingEmail);
        } catch (error) {
            toast.error("Error updating user email.");
        }
    }, [toast])

    return {updateUserEmail}
}
